import { render, staticRenderFns } from "./RelayAddGuests.vue?vue&type=template&id=ef7644c2&scoped=true&"
import script from "./RelayAddGuests.vue?vue&type=script&lang=ts&"
export * from "./RelayAddGuests.vue?vue&type=script&lang=ts&"
import style0 from "./RelayAddGuests.vue?vue&type=style&index=0&id=ef7644c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7644c2",
  null
  
)

export default component.exports